import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPropertyAddress(address, postcode) {
  const rawAddress = (address || '').trim();
  const rawPostcode = (postcode || '').trim();

  if (!rawAddress && !rawPostcode) return '';
  if (!rawAddress) return rawPostcode;
  if (!rawPostcode) return rawAddress;

  const normalizedAddress = rawAddress.replace(/,\s*$/, '').trim();
  const normalizedPostcode = rawPostcode.toUpperCase();
  const addressUpper = normalizedAddress.toUpperCase();

  if (addressUpper === normalizedPostcode) {
    return rawPostcode;
  }

  // If address ends with postcode, remove it
  if (addressUpper.endsWith(normalizedPostcode)) {
    const withoutPostcode = normalizedAddress
      .slice(0, normalizedAddress.length - rawPostcode.length)
      .replace(/,\s*$/, '')
      .trim();

    if (!withoutPostcode) {
      return rawPostcode;
    }

    const withoutPostcodeUpper = withoutPostcode.toUpperCase();

    // Remove trailing country indicators
    let cleanedAddress = withoutPostcode;
    for (const suffix of [', UK', ', United Kingdom', 'UK', 'United Kingdom']) {
      if (cleanedAddress.toUpperCase().endsWith(suffix.toUpperCase())) {
        cleanedAddress = cleanedAddress
          .slice(0, -suffix.length)
          .replace(/,\s*$/, '')
          .trim();
        break;
      }
    }

    // Check if the postcode already appears in the cleaned address
    if (cleanedAddress.toUpperCase().includes(normalizedPostcode)) {
      return cleanedAddress;
    }

    // If the address was duplicate with postcode repeated, use the cleaned base
    if (withoutPostcodeUpper.endsWith(normalizedPostcode)) {
      return withoutPostcode;
    }

    // Address already has postcode in correct place, do not add another one.
    return normalizedAddress;
  }

  // Check if postcode is already in the address (not just at the end)
  if (addressUpper.includes(normalizedPostcode)) {
    return normalizedAddress;
  }

  return `${normalizedAddress}, ${rawPostcode}`;
}

export function formatDateForDisplay(
  value,
  locale = 'en-GB',
  options = { day: 'numeric', month: 'short', year: 'numeric' }
) {
  if (!value) return null;

  let parsedDate;

  if (value instanceof Date) {
    parsedDate = value;
  } else if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    parsedDate = /^\d{4}-\d{2}-\d{2}$/.test(trimmed)
      ? new Date(`${trimmed}T00:00:00`)
      : new Date(trimmed);
  } else {
    parsedDate = new Date(value);
  }

  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  return parsedDate.toLocaleDateString(locale, options);
}
